export default __webpack_public_path__ + "9d7b74c753bd3b2defbc2be310351b8c.webp";